import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { AgentState } from "./types";
import { createAgentAction, updateAgentUrlAction } from "./actions";

export function createAgentReducerBuilder(
  builder: ActionReducerMapBuilder<AgentState>,
) {
  builder.addCase(createAgentAction.pending, (state) => {
    state.isAgentLoading = true;
  });
  builder.addCase(createAgentAction.fulfilled, (state) => {
    state.isAgentLoading = false;
  });
  builder.addCase(createAgentAction.rejected, (state) => {
    state.isAgentLoading = false;
  });
}

export function updateAgentReducerBuilder(
  builder: ActionReducerMapBuilder<AgentState>,
) {
  builder.addCase(updateAgentUrlAction.pending, (state) => {
    state.isAgentLoading = true;
  });
  builder.addCase(updateAgentUrlAction.fulfilled, (state, action) => {
    if (!state.agentValue?.agent_object || !action.payload) return;
    state.agentValue = {
      agent_object: {
        ...state.agentValue.agent_object,
        iframe_src: action.payload.iframe_src,
      },
    };
    state.isAgentLoading = false;
  });
  builder.addCase(updateAgentUrlAction.rejected, (state) => {
    state.isAgentLoading = false;
  });
}
